import {h, Fragment} from "preact"
import { useResponse, AutocompleteElement, Keywords, useCurrencyFormatting } from "@nosto/preact"
import { useEffect } from "preact/hooks"
import { productImagePlaceholder, currency } from "../helpers"
import SubmitButton from "./elements/SubmitButton"

export default function Autocomplete() {
    const { products, keywords } = useResponse()
    const { format } = useCurrencyFormatting()

    if (!products?.hits?.length && !keywords?.hits?.length) {
        return
    }

    useEffect(() => {
        if(!window.Nosto?.migrateToShopifyMarket) return;
        window.Nosto.migrateToShopifyMarket({
            productSectionElement: '.ns-autocomplete .ns-markets',
            productHandleAttribute: 'data-handle',
            productUrlElement: '.product-card__link',
            priceElement: '.ns-price',
            listPriceElement: '.ns-list-price',
        }).then(() => {
            document.querySelectorAll('.ns-autocomplete .ns-markets').forEach(el => {
                const priceEl = el.querySelector('.ns-price'), 
                    listPriceEl = el.querySelector('.ns-list-price');
                
                if(priceEl && currency !== "USD") {
                    priceEl.textContent = `${priceEl.textContent} ${currency}`;
                }
                if(listPriceEl && currency !== "USD") {
                    listPriceEl.textContent = `${listPriceEl.textContent} ${currency}`;
                }
                el.classList.remove('ns-markets');
            })
        })
    }, [ products?.hits ])

    return (
        <div
            class="ns-autocomplete ns-border-box"
            data-nosto-element="autocomplete"
        >
            <div class="ns-autocomplete-section ns-autocomplete-collections">
                {keywords?.hits?.length > 0 && (
                    <>
                    <h3>Related Searches</h3>
                    <ul class="ns-keywords-list">
                        <Keywords
                            hits={keywords.hits}
                            keywordComponent={Keyword}
                            elementComponent={Element}
                            keywordInCategoryComponent={KeywordInCategory}
                        />
                    </ul>
                    </>
                )}
            </div>

            <div class="ns-autocomplete-section ns-autocomplete-products">
                {products?.hits?.length > 0 && (
                    <>
                    <h3>Products</h3>
                    <ul class="ns-product-list">
                        {products?.hits?.map(hit => (
                            <li key={hit.productId}>
                                <AutocompleteElement hit={hit}>
                                    <div class="ns-markets" data-handle={hit.url.split('/products/')[1]}>
                                        <div
                                            data-url={hit.url}
                                            class="ns-image-wrap"
                                            data-nosto-element="product"
                                        >
                                            <img
                                                class="ns-image"
                                                src={hit.imageUrl?.replace('.jpg', '_520x.jpg')?.replace('.png', '_520x.png')?.replace('.webp', '_520x.webp') ?? productImagePlaceholder}
                                                alt={`${hit.name} - ${hit.description}`}
                                            />
                                        </div>
                                        <div class="ns-product-title">
                                            <a class="product-card__link" href={hit.url}>
                                                {hit.name}
                                            </a>
                                        </div>
                                        <div class="ns-price-wrap">
                                            <span class="ns-price">{format(hit.price)}</span>
                                            {hit.listPrice && hit.listPrice > hit.price && (
                                                <span class="ns-list-price">
                                                    {format(hit.listPrice)}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </AutocompleteElement>
                            </li>
                        ))}
                    </ul>
                    </>
                )}
            </div>
        </div>
    )
}

function Keyword({ hit }) {
    return (
        <span data-nosto-element="keyword">
            {hit?._highlight?.keyword ? (
                <span
                    dangerouslySetInnerHTML={{
                        __html: hit._highlight.keyword
                    }}
                ></span>
            ) : (
                hit.keyword
            )}
        </span>
    )
}

function Element({ hit, keywordComponent, filter }) {
    return (
        <li>
            <AutocompleteElement hit={hit} filter={filter} class="ns-clickable">
                {keywordComponent}
            </AutocompleteElement>
        </li>
    )
}

function KeywordInCategory({ category, children }) {
    return (
        <span class="ns-clickable">
            {category?.value ? (
                <span>
                    {children}{" "}
                    <span class="ns-keyword-in-category">
                        in <span>{category.value}</span>
                    </span>
                </span>
            ) : (
                children
            )}
        </span>
    )
}
